function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import "jquery";
import Validations from "./Validations";
import * as Ajax from '../ajax/Ajax';
/**
 * 共通
 */

var Common = /*#__PURE__*/function () {
  /**
   * 初期化を行います。
   */
  function Common() {
    _classCallCheck(this, Common);

    /**
     * サブミット時の自動ブロックを行うかどうかを示す値
     */
    this.blockedUI = false;
    /**
     * 画面の移動確認を行うかどうかを示す値
     */

    this.beforeunloadOff = false;
    /**
     * 入力検証
     */

    this.valid = new Validations();
    /**
     * ゲームインスタンス
     */

    this.gameInstance = null;
    /**
     * ゲームインスタンスが読み込み済みかどうかを示す値
     */

    this.gameLoaded = false;
    /**
     * ゲーム読込
     */

    this.gameLoad = null;
    /**
     * 会議参加QRコードフォーマット
     */

    this.qrCodeSessionJoinFormat = "whiteroom://join-session?room-id={0}";
    /**
     * クリップボードに文字列をコピーします
     *
     * @param s 文字列
     */

    this.copyToClipboard = function (s) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(s);
      } else {
        var textarea = document.createElement('textarea');
        textarea.value = s;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
      }
    };

    $.validator.unobtrusive.adapters.addBool("nowhitespace");
    $.validator.unobtrusive.adapters.addBool("datetime");
    $.validator.unobtrusive.adapters.addBool("decimalnumber");
    $.validator.unobtrusive.adapters.addBool("phone");
  }
  /**
   * HTMLの構造が組み立てられた後すぐに実施する処理
   */


  _createClass(Common, [{
    key: "ready",
    value: function ready() {
      var _this = this;

      // form の Submit 時に2度押し抑制処理を実施します。
      $('html').submit(function () {
        if (_this.blockedUI || document.readyState != null && document.readyState != "complete" && document.readyState != "interactive") {
          return false;
        } else {
          _this.blockedUI = true;
          return true;
        }
      }); // 最後のアクティブなAjaxリクエストが終了する時に2度押し抑制を解除します。

      $(document).ajaxStop(function () {
        _this.blockedUI = false;
      }); // 2度押し抑制時にキーボード操作を抑制します。

      $(document).on('keydown', function (e) {
        if (_this.blockedUI) {
          e.preventDefault();
        }
      });
    }
    /**
     * 共通部のイベントバインド処理
     */

  }, {
    key: "bind",
    value: function bind() {
      var _this2 = this;

      //XXX 非表示項目も入力チェックを行う
      if ($("form").length > 0 && $("form").data("validator") != undefined) {
        var validatorSettings = $("form").data("validator").settings;
        validatorSettings.ignore = "";
      } // 入力検証


      $.validator.setDefaults(this.valid.validationOptions());
      $.validator.addMethod("nowhitespace", this.valid.nowhitespace);
      $.validator.addMethod("datetime", this.valid.datetime);
      $.validator.addMethod("decimalnumber", this.valid.decimalnumber); // 対象エレメントの内容が変更された場合に、更新フラグを変更します。

      $("#MainForm").on("change", function (e) {
        var $target = $(e.target);

        if (!_this2.toBool($target.data('updateUncheck'), false)) {
          $("#IsUpdate").val("True");
        }
      }); // 初期フォーカスを適用します。

      $(window).on('load', function () {
        $('input:visible:enabled:not(:disabled):not([readonly]),button:visible:enabled:not(:disabled)').eq(0).focus();
      }); // 「入力中の内容は破棄されます。よろしいですか？」を表示するか制御します。

      $(window).on('beforeunload', function () {
        if (_this2.beforeunloadOff) {
          return;
        }

        if (_this2.toBool($("#IsInvalidateDialog").val(), false) && _this2.toBool($("#IsUpdate").val(), false)) {
          return "入力中の内容は破棄されます。よろしいですか？";
        } else {
          return;
        }
      }); // キーダウン操作を制御します。

      $(document).on("keydown", function (e) {
        var $target = $(e.target);
        var tagName = $target.prop("tagName").toLowerCase();
        var type = $target.prop("type");

        if (type) {
          type = type.toLowerCase();
        }

        switch (e.keyCode) {
          //XXX エンターを抑制
          case 13:
            return tagName == "textarea" && !($target.attr("readonly") || $target.attr("disabled"));
          //XXX バックスペースで前画面に戻るのを抑制

          case 8:
            return (tagName == "input" && (type == "text" || type == "number" || type == "password" || type == "url") || tagName == "textarea") && !($target.attr("readonly") || $target.attr("disabled"));
          //XXX IEでモーダルからIEのアドレスバーにフォーカスが移ってからモーダルにタブが戻らないため

          case 9:
            if (e.shiftKey) {
              if ($target.hasClass('modal_init_focus')) {
                $('.modal_last_focus').eq(0).focus();
                return false;
              }
            } else {
              if ($target.hasClass('modal_last_focus')) {
                $('.modal_init_focus').eq(0).focus();
                return false;
              }
            }

            return true;

          default:
            return true;
        }
      });
      var menuCont = $('#menuCont');
      var menuIcon = $('#menuIcon');
      $('#menuLink').on('click', function (e) {
        menuIcon.toggleClass('header__menu--active');
        menuCont.toggleClass('menu--show');
        e.preventDefault();
      });
      var userCont = $('#userCont');
      $('#userLink').on('click', function (e) {
        userCont.toggleClass('user__cont--show');
        e.preventDefault();
      });
      $('#ProfileLink').on('click', function (e) {
        _this2.submit(function () {
          _this2.createAction("DesignationTransition");

          _this2.createHiddenElement("TransitionName", "Profile");
        }, false, true);

        e.preventDefault();
      });
      $('#SessionLink').on('click', function (e) {
        if (e.ctrlKey || e.shiftKey || e.metaKey) return;

        _this2.submit(function () {
          _this2.createAction("MenuTransition");

          _this2.createHiddenElement("TransitionName", "Session");
        }, false, true);

        e.preventDefault();
      });
      $('#SessionHistoryLink').on('click', function (e) {
        if (e.ctrlKey || e.shiftKey || e.metaKey) return;

        _this2.submit(function () {
          _this2.createAction("MenuTransition");

          _this2.createHiddenElement("TransitionName", "SessionHistory");
        }, false, true);

        e.preventDefault();
      });
      $('#OrganizationLink').on('click', function (e) {
        if (e.ctrlKey || e.shiftKey || e.metaKey) return;

        _this2.submit(function () {
          _this2.createAction("MenuTransition");

          _this2.createHiddenElement("TransitionName", "Organization");
        }, false, true);

        e.preventDefault();
      });
      $('#UserLink').on('click', function (e) {
        if (e.ctrlKey || e.shiftKey || e.metaKey) return;

        _this2.submit(function () {
          _this2.createAction("MenuTransition");

          _this2.createHiddenElement("TransitionName", "User");
        }, false, true);

        e.preventDefault();
      });
      $('#UserGroupLink').on('click', function (e) {
        if (e.ctrlKey || e.shiftKey || e.metaKey) return;

        _this2.submit(function () {
          _this2.createAction("MenuTransition");

          _this2.createHiddenElement("TransitionName", "UserGroup");
        }, false, true);

        e.preventDefault();
      });
      $('#InformationLink').on('click', function (e) {
        if (e.ctrlKey || e.shiftKey || e.metaKey) return;

        _this2.submit(function () {
          _this2.createAction("MenuTransition");

          _this2.createHiddenElement("TransitionName", "Information");
        }, false, true);

        e.preventDefault();
      });
      $('#InformationViewLink').on('click', function (e) {
        if (e.ctrlKey || e.shiftKey || e.metaKey) return;

        _this2.submit(function () {
          _this2.createAction("MenuTransition");

          _this2.createHiddenElement("TransitionName", "InformationView");
        }, false, true);

        e.preventDefault();
      });
      $('#InstallLink').on('click', function (e) {
        if (e.ctrlKey || e.shiftKey || e.metaKey) return;

        _this2.submit(function () {
          _this2.createAction("MenuTransition");

          _this2.createHiddenElement("TransitionName", "Install");
        }, false, true);

        e.preventDefault();
      });
      $('#StatisticsLink').on('click', function (e) {
        if (e.ctrlKey || e.shiftKey || e.metaKey) return;

        _this2.submit(function () {
          _this2.createAction("MenuTransition");

          _this2.createHiddenElement("TransitionName", "Statistics");
        }, false, true);

        e.preventDefault();
      });
      $('#SalesLink').on('click', function (e) {
        if (e.ctrlKey || e.shiftKey || e.metaKey) return;

        _this2.submit(function () {
          _this2.createAction("MenuTransition");

          _this2.createHiddenElement("TransitionName", "Sales");
        }, false, true);

        e.preventDefault();
      });
      $('#userLink_SmartPhone').on('click', function (e) {
        if (e.ctrlKey || e.shiftKey || e.metaKey) return;

        _this2.submit(function () {
          _this2.createAction("DesignationTransition");

          _this2.createHiddenElement("TransitionName", "Profile");
        }, false, true);

        e.preventDefault();
      });
      $('#menuBack').on('click', function (e) {
        if (e.ctrlKey || e.shiftKey || e.metaKey) return;

        _this2.submit(function () {
          _this2.createAction("Back");
        }, false, true);

        e.preventDefault();
      });
      $('#LogoutLink').on('click', function (e) {
        _this2.submit(function () {
          _this2.createAction("Logout");
        }, false, true);

        e.preventDefault();
      });
    }
    /**
     * 指定されたname,valueのHiddenエレメントを生成しForm要素に追加します。
     * 既に存在する場合は、存在するHiddenエレメントのvalueを書き換えます。
     *
     * @param name Hiddenエレメントのname
     * @param value Hiddenエレメントに設定するvalue
     */

  }, {
    key: "createHiddenElement",
    value: function createHiddenElement(name, value) {
      this.createHiddenElementTagetForm($("#MainForm"), name, value);
    }
    /**
     * 遷移先を指定するActionを生成します。
     *
     * @param action 設定するaction
     */

  }, {
    key: "createAction",
    value: function createAction(action) {
      this.createHiddenElement("Action", action);
    }
    /**
     * エレメントを操作された際のサブミット処理を行います。
     *
     * @param fn 処理
     * @param $el エレメント
     * @param isValidation 入力検証を行うかどうか
     * @param isInvalidate 「入力中の内容は破棄されます。よろしいですか？」を表示するかどうか
     */

  }, {
    key: "submitForElement",
    value: function submitForElement(fn, $el, isValidation, isInvalidate) {
      this.submit(fn, this.toBool($el.data('validation'), isValidation), this.toBool($el.data('invalidate'), isInvalidate));
    }
    /**
     * サブミット処理を行います。
     *
     * @param fn 処理
     * @param isValidation 入力検証を行うかどうか
     * @param isInvalidate 「入力中の内容は破棄されます。よろしいですか？」を表示するかどうか
     */

  }, {
    key: "submit",
    value: function submit(fn, isValidation, isInvalidate) {
      if (!this.validate(isValidation)) {
        return;
      }

      if (!this.invalidate(isInvalidate)) {
        return;
      }

      fn();
      this.beforeunloadOff = true;
      $("#MainForm").submit();
    }
    /**
     * エレメントを操作された際のAjaxでの画面書き換え処理を行います。（表示行の追加・削除などのスクロール位置や画面のリフレッシュが目立つ箇所で利用します。）
     *
     * @param fn 処理
     * @param $el エレメント
     * @param isValidation 入力検証を行うかどうか
     * @param isInvalidate 「入力中の内容は破棄されます。よろしいですか？」を表示するかどうか
     */

  }, {
    key: "ajaxForElement",
    value: function ajaxForElement(fn, $el, isValidation, isInvalidate) {
      this.ajax(fn, this.toBool($el.data('validation'), isValidation), this.toBool($el.data('invalidate'), isInvalidate));
    }
    /**
     * Ajaxでの画面書き換え処理を行います。（表示行の追加・削除などのスクロール位置や画面のリフレッシュが目立つ箇所で利用します。）
     *
     * @param actionName 処理
     * @param validation 入力検証を行うかどうか
     * @param isInvalidate 「入力中の内容は破棄されます。よろしいですか？」を表示するかどうか
     */

  }, {
    key: "ajax",
    value: function ajax(fn, validation, isInvalidate) {
      if (!this.validate(validation)) {
        return;
      }

      if (!this.invalidate(isInvalidate)) {
        return;
      }

      fn();
      Ajax.Page($("#MainForm").attr("action"), $("#MainForm").serialize());
    }
    /**
     * 入力値検証を行います。
     *
     * @param isValidation 入力検証を行うかどうか
     */

  }, {
    key: "validate",
    value: function validate(isValidation) {
      return this.validateTargetForm($("#MainForm"), isValidation);
    }
    /**
     * 送信処理検証を行います。
     *
     * @param isInvalidate 「入力中の内容は破棄されます。よろしいですか？」を表示するかどうか
     */

  }, {
    key: "invalidate",
    value: function invalidate(isInvalidate) {
      if (isInvalidate) {
        if (this.toBool($("#IsInvalidateDialog").val(), false) && this.toBool($("#IsUpdate").val(), false)) {
          return confirm("入力中の内容は破棄されます。よろしいですか？");
        } else {
          return true;
        }
      } else {
        return true;
      }
    }
    /**
     * 指定されたname,valueのHiddenエレメントを生成しForm要素に追加します。
     * 既に存在する場合は、存在するHiddenエレメントのvalueを書き換えます。
     *
     * @param tagetForm ターゲットフォーム
     * @param name Hiddenエレメントのname
     * @param value Hiddenエレメントに設定するvalue
     */

  }, {
    key: "createHiddenElementTagetForm",
    value: function createHiddenElementTagetForm(tagetForm, name, value) {
      var hidden = $(':hidden[name="' + name + '"]');

      if (hidden.length == 0) {
        tagetForm.append($("<input>", {
          type: 'hidden',
          name: name,
          id: name,
          value: value
        }));
      } else {
        hidden.val(value);
      }
    }
    /**
     * 入力値検証を行います。
     *
     * @param tagetForm ターゲットフォーム
     * @param validation 入力検証を行うかどうか
     */

  }, {
    key: "validateTargetForm",
    value: function validateTargetForm(tagetForm, validation) {
      if (validation) {
        $.validator.unobtrusive.parse(tagetForm);
        tagetForm.validate(this.valid.validationOptions());
        return tagetForm.valid();
      } else {
        //XXX 無効化の方法が不明確なため
        tagetForm.validate(this.valid.validationOptions()).cancelSubmit = true;
        return true;
      }
    }
    /**
     * Boolean型に変換します。
     * c#ではTrue/Falseと頭が大文字になるため
     *
     * @param s 文字列
     * @param defaultValue デフォルト
     */

  }, {
    key: "toBool",
    value: function toBool(s, defaultValue) {
      if (s == undefined || s == null) {
        return defaultValue;
      }

      if (typeof s == "boolean") {
        return s;
      }

      return s.toLowerCase() == "true";
    }
  }]);

  return Common;
}();

export { Common as default };